import React from 'react';
import { DividerProps } from './types';


export default function Divider({ color = 'bg-black', width = 'w-full', height = 'h-1', className = '', ...extraProps }: DividerProps): JSX.Element {
  return <div className={[color, width, height, className].join(' ')} {...extraProps}></div>
}